import React,{Component} from 'react'
import { connect } from 'react-redux';

import ValidationOverlay from './validationOverlay.jsx';
import Select from 'react-select';
import Dialog from '../../../commonModules/interface/Dialog';
import Notif from '../../../commonModules/interface/Notif';
import CardPage from '../../../commonModules/layouts/CardPage.jsx';
import PopUp from '../../../commonModules/interface/PopUp.jsx';
import { Grid, Typography, CircularProgress, Box } from '@material-ui/core';
import { InputSelectMagasin } from '../../../commonModules/interface/form-input-inline.jsx';
import { Alert } from '@material-ui/lab';

class ChangeStatusBox extends Component {
    state = {
        boxList:[],
        boxStatus:{value:"", label:""},
        boxID:{value:"", label:""},
        isSearching: false,
        searchQuery: "",
        accessDenied: false,
        accessDeniedMessage: "",
        errors:{
            boxStatus:"",
            boxID:"",
        },
        notif:{
            title:"", 
            type: "", 
            message:"",
            show:false
        },
        msg: "",
        collapse: 2,
    }

    // Debounce timer reference
    searchDebounceTimer = null;

    componentDidMount=() => {
        // No initial load - search is triggered by user input
        console.log('[INFO], ChangeStatusBox, Component mounted, waiting for user search');
    }

    componentWillUnmount() {
        // Clear debounce timer on unmount
        if (this.searchDebounceTimer) {
            clearTimeout(this.searchDebounceTimer);
        }
    }

    searchBoxes = async (searchQuery) => {
        if (searchQuery.length < 2) {
            // Clear results if search query is too short
            this.setState({ 
                boxList: [],
                isSearching: false
            });
            return;
        }

        this.setState({ isSearching: true });
        
        try{
            let res = await fetch('/association/search',{
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    search: searchQuery,
                    status: ['OK','PaymentLate','PaygBlocked','FullyPaid'],
                    pageSize: 50,
                    page: 1
                }),
                credentials: 'same-origin',
            })
            const data = await res.json();
            console.log('[INFO], searchBoxes, response received', data);
            
            if(!data.error && data.items){
                let boxes = data.items.map(item => ({
                    value: item.boxAssoId, 
                    label: `${item.boxId} - ${item.clientName || 'Sans client'}`
                }));
                
                this.setState({
                    boxList: boxes,
                    isSearching: false,
                    accessDenied: false
                })
            } else {
                // Gestion des erreurs d'accès
                const isAccessDenied = data.errorCode === 401 || data.errorCode === 403 || 
                    (data.message && data.message.toLowerCase().includes('accès')) ||
                    (data.message && data.message.toLowerCase().includes('autorisation'));
                
                this.setState({
                    boxList: [],
                    isSearching: false,
                    accessDenied: isAccessDenied || false,
                    accessDeniedMessage: data.message || "Erreur lors de la recherche"
                })
            }
        } catch (error) {
            console.log('[ERROR], searchBoxes, error', error);
            this.setState({ 
                boxList: [],
                isSearching: false,
                accessDenied: true,
                accessDeniedMessage: "Une erreur est survenue lors de la recherche. Veuillez réessayer."
            });
        }
    }

    handleSearchInputChange = (event, newInputValue) => {
        this.setState({ searchQuery: newInputValue });

        // Clear previous debounce timer
        if (this.searchDebounceTimer) {
            clearTimeout(this.searchDebounceTimer);
        }

        // Set new debounce timer
        this.searchDebounceTimer = setTimeout(() => {
            this.searchBoxes(newInputValue);
        }, 300); // 300ms debounce
    }
    
    handleChange = (e) =>{
        let value = e.target.value
        let name = e.target.name
        this.setState({
            [name]: value
        })
    }
    handleChange2 = (boxStatus) => {
        this.setState({ boxStatus });
        console.log(`Option selected:`, boxStatus);
      }
    validate = () =>{
        let noErrors = true
        let errors = {}
        const fields = ["boxID", "boxStatus"]
        fields.map(field =>{
            if (this.state[field].value === ""){
                errors[field] = 'Veuillez remplir ce champ'
                noErrors = false
            } else {
                errors[field]= ''
            }
        })
                    
        this.setState({...this.state,errors})
        console.log("VALIDATE",{noErrors, errors});
        
        return noErrors
    }
    handleSubmit = async () =>{
        if(this.validate()){
            let data = {}
            data.boxAssoId = this.state.boxID.value
            data.status = this.state.boxStatus.value

            try {
                let req = await fetch('/box/changeStatus',{
                    method:'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                    },
                    body: JSON.stringify(data),
                    credentials: 'same-origin',
            
                })
                const res = await req.json()
                console.log({res});
                if(!res.error){
                    this.clearForms()
                    this.notif("success", "Statut Mis à Jour" , "Sucess")
                    let timer = setTimeout(() => {
                        this.props.onCloseOverlay()
                      }, 1500);
                } else {
                    console.log({res});
                    this.notif("danger", res.error.message , "Erreur")
                    
                }
            } catch (error) {
                this.notif("danger", error, "Erreur")
            }
        } else {
            this.notif(
                "danger",
                "Le formulaire contient des erreurs",
                "Erreur"
            )
        }
    }
    notif = (type, msg, title = null) => {
        this.setState({
            notif: {
                title:title, 
                type, 
                message:msg,
                show:true
            }
        })
    }
    clearForms = () => {
        this.setState({
            boxStatus:{value:"", label:""},
            boxID:{value:"", label:""},
            errors:{
                boxStatus:"",
                boxID:"",
            },
            notif:{
                title:"", 
                type: "", 
                message:"",
                show:false
            },
        })
    }
    render(){
        const { boxList, isSearching, searchQuery, accessDenied, accessDeniedMessage } = this.state
        
        console.log("[STATE] paygo new User", this.state, this.state.boxList);
        
        return(
                <PopUp
                    title="Modifier le statut d'une Box"
                    submitAction={accessDenied ? this.props.onCloseOverlay : this.handleSubmit}
                    close={this.props.onCloseOverlay}
                    maxWidth="sm"
                >

                    {/* MOVE TO PARENT COMPONENT */}
                    <Notif
                        show={this.state.notif.show} 
                        title={this.state.notif.title} 
                        type={this.state.notif.type} 
                        message={this.state.notif.message} 
                        close={()=> this.setState({
                            notif:{
                                ...this.state.notif,
                                show:false,
                            }
                        })} 
                    />
                    {/* MOVE TO PARENT COMPONENT */}
                    
                    {accessDenied ? (
                        <Box display="flex" flexDirection="column" alignItems="center" minHeight="150px" p={2}>
                            <Alert severity="warning" style={{ width: '100%', marginBottom: '16px' }}>
                                <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                                    Accès refusé
                                </Typography>
                                <Typography variant="body2">
                                    {accessDeniedMessage}
                                </Typography>
                            </Alert>
                            <Typography variant="body2" color="textSecondary" style={{ marginTop: '8px', textAlign: 'center' }}>
                                Veuillez contacter un administrateur si vous pensez que c'est une erreur.
                            </Typography>
                        </Box>
                    ) : (
                        <>
                            {/* <form> */}
                            <Grid container spacing={2} >
                                <Grid item xs={12}>
                                    <InputSelectMagasin
                                        label="ID Box"  
                                        value={this.state.boxID}
                                        onChange={(option) => this.setState({boxID:option})}
                                        inputValue={searchQuery}
                                        onInputChange={this.handleSearchInputChange}
                                        options={boxList}
                                        helperText={this.state.errors.boxID || "Tapez au moins 2 caractères pour rechercher"}
                                        loading={isSearching}
                                        noOptionsText={
                                            searchQuery.length < 2 
                                                ? "Tapez au moins 2 caractères pour rechercher" 
                                                : isSearching 
                                                    ? "Recherche en cours..." 
                                                    : "Aucune box trouvée"
                                        }
                                    />
                                </Grid>                                                
                                <Grid item xs={12}>
                                    <InputSelectMagasin
                                        label="Statut Box"  
                                        value={this.state.boxStatus}
                                        onChange={(option)=>this.setState({boxStatus:option})}
                                        options={[
                                            {value:"DEMO", label:"Box Demo"},
                                            {value:"REMOVED", label:"Box Retirée"},
                                            {value:"REAFFECTED", label:"Box Reaffectée"},
                                        ]}
                                        helperText={this.state.errors.boxStatus}
                                    />
                                </Grid>
                            </Grid>
                            { this.state.boxStatus.value == "REMOVED"  &&
                                <Alert severity="error">
                                    Avez-vous pensez à récupérer les stocks du client ? Et à faire un retour de stock dans le magasin d'OCCASION?
                                </Alert>
                            // <Typography variant="h6" style={{
                            //     color: "#FF0000",
                            //     fontWeight: "bold"
                            //     }}
                            // >
                            // </Typography>
                            }
                            {/* </form> */}
                        </>
                    )}
                </PopUp>

        )
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        CLIENTS: state.clients
    }
}

export default connect(mapStateToProps)(ChangeStatusBox);
